<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>代理员工列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-form
        size="mini"
        :inline="true"
        :model="searchForm"
        :rules="searchRules"
        ref="searchForRef"
        label-width="100px"
        autocomplete="on"
      >
        <el-form-item>
          <el-input v-model="searchForm.keywords" placeholder="姓名|手机号" clearable type="text"></el-input>
        </el-form-item>
        <el-form-item>
          <el-cascader
            v-model="searchForm.department_id"
            :props="{ value: 'id', label: 'name', checkStrictly: true }"
            :options="departmentData"
            :show-all-levels="false"
            @change="changeDepartmentValue">
          </el-cascader>

        </el-form-item>
        <el-form-item>
          <el-button type="success" size="mini" @click="searchSubmit()">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="addData">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table
        ref="multipleTable"
        :data="tableLoadData"
        size="mini"
        stripe
        border
      >
        <el-table-column :index="indexMethod" type="index" label="序号" width="50"></el-table-column>

        <el-table-column
          label="所属部门"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.department?scope.row.department.name:''}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="姓名"
          prop="name_cn"
          width="120"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          label="性别"
          width="80"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.sex==1?"男":(scope.row.sex==0?'女':'')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="年龄"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.id_code|parseIDCard}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="手机号"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.mobile}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="工作状态"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.work_status==1?"在岗":(scope.row.work_status==0?'离岗':'')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="是否在建"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
               {{scope.row.status==1?"是":(scope.row.status==0?'否':'')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="社保状况"
          width="120"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
             {{scope.row.insurance_status}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="证书数量"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.insurance_status}}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="140"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>{{ scope.row.add_time | dateFormat }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="200">
          <template slot-scope="scope">
            <el-button  type="text" size="mini" @click="goInfo(scope.row)">查看</el-button>
            <el-button @click="goEdit(scope.row)"  type="text" size="mini">修改</el-button>
            <el-button @click="addCert(scope.row)"  type="text" size="mini">添加证书</el-button>
            <el-button @click="goDel(scope.row)"  type="text" size="mini">删除</el-button>
          </template>
        </el-table-column>


      </el-table>
      <!-- 分页 -->
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">

        <el-form-item label="保司名称" prop="name">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入保司名称"></el-input>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import moment from 'moment'     //日期时间转换
  export default {
    name: "proxyEmployeeList",
    components: {

    },
    props: {},
    data() {
      return {
        dicList:[],
        // 搜索
        searchForm: {
          keywords: "",
          department_id:''
        },
        departmentData: [],
        searchRules: {
          name: [
            { required: true, message: "请输入", trigger: "blur" }
          ],
        },
        // 数据
        tableLoadData: [],
        pageNum:1,// 当前页码
        pageSize:10,// 每页大小
        total:0,//总条目数

        showType: '',

        roleList: [],

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            {
              min: 3,
              max: 15,
              message: "长度在 3 到 15 个字符",
              trigger: "blur",
            }
          ],

        },

        dialogFormVisible: false,
        title: '',
        form: {
          name: '',
        },

      };
    },
    created() {
      this.showType = this.$route.query.showType;
      this.DataList()
      this.DepartmentList()
    },
    mounted() {
    },
    filters: {
      /**
       * @param {
       *
       * }
       */
      //时间格式化
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      parseIDCard(idCard) {
    // 正则表达式匹配身份证号格式
    var reg = /^\d{17}[\dXx]$/;

    if (reg.test(idCard)) {
      // 提取出生日期
      var birthday = idCard.substring(6, 14);
      var year = birthday.substring(0, 4);
      // var month = birthday.substring(4, 6);
      // var day = birthday.substring(6, 8);

      // 计算年龄
      var currentYear = new Date().getFullYear();
      var age = currentYear - parseInt(year);

      // 提取性别
      //var genderCode = parseInt(idCard.charAt(16));
     // var gender = genderCode % 2 === 0 ? "女" : "男";
      return age;
      // return {
      //   birthday: year + "-" + month + "-" + day,
      //   age: age,
      //   gender: gender
      // };
    }

    // 测试
    // var idCard = "身份证号码"; // 替换为实际身份证号码
    // var result = parseIDCard(idCard);
    //
    // if (result !== null) {
    //   console.log("出生日期：" + result.birthday);
    //   console.log("年龄：" + result.age);
    //   console.log("性别：" + result.gender);
    // } else {
    //   console.log("身份证号格式不正确");
    // }
    //

    return ''; // 身份证号格式不正确
  },


  statusFilter(status) {
        if (status == 0) {
          return "待审核";
        } else if (status == 1) {
          return "已审核";
        } else if (status == 2) {
          return "已出单";
        } else if (status == 3) {
          return "已完成";
        } else if (status == 4) {
          return "取保";
        } else if (status == 5) {
          return "退单";
        }
      },

    },
    methods: {
      searchSubmit() {
         this.tableLoadData=[];
         this.total=0;
         this.pageNum=1;
         this.DataList();
      },
      DepartmentList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.departmentTree(param).then(res=>{
          if(res.code == 200){
            this.departmentData = res.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      changeDepartmentValue(e){
        let lastElement = e[e.length-1];
        this.searchForm.department_id = lastElement
      },
      addCert(row){
        this.$router.push({
          path:'/employeeCertificateList',
          query:{
            employee_id:row.id
          }
        })
      },
      goInfo(row){
        this.$router.push({
          path:'/proxyEmployeeInfo',
          query:{
            id:row.id
          }
        })
      },
      goEdit(row){
        this.$router.push({
          path:'/proxyEmployeeForm',
          query:{
            id:row.id
          }
        })
      },
      goCategory(){
        this.$router.push('/newsCategory')
      },
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          shop_id:sessionStorage.getItem('shop_id'),
          proxy_id:sessionStorage.getItem('proxy_id'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if(this.searchForm.keywords){
          param.keywords=this.searchForm.keywords;
        }
        if(this.searchForm.department_id){
          param.department_id=this.searchForm.department_id;
        }


        this.$axios.proxyEmployeeListP(param).then(res=>{
          if(res.code == 200){
            //  console.log(res,1111);
            this.tableLoadData = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      departData(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findTree(param).then(res=>{
          if(res.code == 200){
            this.rightslist = res.data.data
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 新增
      addData() {
        // this.title = '新增'
        // this.form = {
        //   name: '',
        // }
        // this.dialogFormVisible = true
        this.$router.push('/proxyEmployeeForm')
      },
      handelEdit(index) {
        this.id = index.data.row.id
        this.title = '编辑'
        this.form = {
          name: this.name,
        }
        this.dialogFormVisible = true
        // this.form = {...row};
        // 或者
        this.form = JSON.parse(JSON.stringify(index.data.row))
      },

      reset_dialogForm(formName) {
        this.dialogFormVisible = false
        this.$nextTick(() => {
          this.$refs[formName].resetFields()
        })
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(!this.id){
              const param = {
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id: sessionStorage.getItem('company_id'),
                access_token: sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }else{
              const param = {
                id: this.form.id,
                name: this.form.name,
                operator_id: sessionStorage.getItem('user_id'),
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
              }
              this.$axios.insuranceCorpSave(param).then(res =>{
                if(res.code == 200){
                  this.$message.success(res.msg)
                  this.DataList()
                  this.dialogFormVisible = false
                }else{
                  this.$message.error(res.msg);
                }
              })
            }

          }
        })
      },
      goDel(e) {
        console.log(e);
        this.$confirm('此操作将删除该员工, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          this.$axios.proxyEmployeeDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.pageNum=1;
              this.tableLoadData=[];
              this.total=0;
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
        this.teamDialog = false
      },


    },
  };
</script>
<style>

</style>
